// BuildMyShifts role permissions
// Roles: admin, manager, staff, viewer
export const rolePermissions = {
  admin: {
    create_rotas: true,
    publish_rotas: true,
    assign_shifts: true,
    approve_swaps: true,
    manage_users: true,
    manage_groups: true,
    manage_availability: true,
    view_rotas: true,
    view_analytics: true,
    manage_subscription: true,
    manage_policies: true,
    configure_settings: true,
    view_ai_insights: true,
    enable_auto_assign: true,
    // ── New permissions ──
    manage_templates: true,
    override_compliance: true,
    configure_pay_rules: true,
    configure_role_hierarchy: true,
    view_fatigue_scores: true,
    view_fairness_reports: true,
    view_cost_projections: true,
  },
  manager: {
    create_rotas: true,
    publish_rotas: true,
    assign_shifts: true,
    approve_swaps: true,
    manage_users: false,
    manage_groups: true,
    manage_availability: true,
    view_rotas: true,
    view_analytics: true,
    manage_subscription: false,
    manage_policies: true,
    configure_settings: false,
    view_ai_insights: true,
    enable_auto_assign: true,
    // ── New permissions ──
    manage_templates: true,
    override_compliance: true,
    configure_pay_rules: false,
    configure_role_hierarchy: false,
    view_fatigue_scores: true,
    view_fairness_reports: true,
    view_cost_projections: true,
  },
  staff: {
    create_rotas: false,
    publish_rotas: false,
    assign_shifts: false,
    approve_swaps: false,
    manage_users: false,
    manage_groups: false,
    manage_availability: true,
    view_rotas: true,
    view_analytics: false,
    manage_subscription: false,
    manage_policies: false,
    configure_settings: false,
    view_ai_insights: false,
    enable_auto_assign: false,
    // ── New permissions ──
    manage_templates: false,
    override_compliance: false,
    configure_pay_rules: false,
    configure_role_hierarchy: false,
    view_fatigue_scores: false,
    view_fairness_reports: false,
    view_cost_projections: false,
  },
  viewer: {
    create_rotas: false,
    publish_rotas: false,
    assign_shifts: false,
    approve_swaps: false,
    manage_users: false,
    manage_groups: false,
    manage_availability: false,
    view_rotas: true,
    view_analytics: false,
    manage_subscription: false,
    manage_policies: false,
    configure_settings: false,
    view_ai_insights: false,
    enable_auto_assign: false,
    // ── New permissions ──
    manage_templates: false,
    override_compliance: false,
    configure_pay_rules: false,
    configure_role_hierarchy: false,
    view_fatigue_scores: false,
    view_fairness_reports: false,
    view_cost_projections: false,
  },
};

export function hasPermission(userData, permission) {
  if (!userData) return false;
  if (userData.role === 'admin') return true;

  const roleKeyRaw = String(userData.role || 'staff').toLowerCase();
  const roleKey = roleKeyRaw.replace(/[_\s-]+/g, '');

  // Support super-user custom role from BuildMyChecks compatibility
  const custom = (userData.customRoles || []).map(r => String(r).toLowerCase());
  const customNormalized = custom.map(c => c.replace(/[_\s-]+/g, ''));
  if (customNormalized.includes('super') || customNormalized.includes('superuser')) {
    return !!(rolePermissions.manager && rolePermissions.manager[permission]);
  }

  if (['super', 'superuser', 'manager'].includes(roleKey)) {
    return !!(rolePermissions.manager && rolePermissions.manager[permission]);
  }

  return !!(rolePermissions[roleKey] && rolePermissions[roleKey][permission]);
}

export function canManageRota(userData) {
  return hasPermission(userData, 'create_rotas') || hasPermission(userData, 'assign_shifts');
}

export function canViewRota(userData) {
  return hasPermission(userData, 'view_rotas');
}

export function isAdmin(userData) {
  return userData?.role === 'admin';
}

export function isManager(userData) {
  return ['admin', 'manager'].includes(userData?.role);
}

export const ROLES = rolePermissions;

const permissionsModule = { rolePermissions, ROLES, hasPermission, canManageRota, canViewRota, isAdmin, isManager };
export default permissionsModule;
